/**
 * Browser print-preview for POS / Invoice Print (thermal, A4, A5).
 * Opens the same Print Preview document as InvoicePrint.printPreview().
 */

function money(amount) {
  return (Number(amount) || 0).toFixed(2);
}

function esc(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function absUrl(src) {
  if (!src) return "";
  try {
    return new URL(src, window.location.href).href;
  } catch (err) {
    return src;
  }
}

const INVOICE_CSS = `
.hm-paper { width: 100%; background: #fff; box-sizing: border-box; }
.hm-paper-a5 { }
.hm-paper-thermal { }
.hm-inv { color: #1c1917; }
.hm-inv-thermal {
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1.45;
}
.th-center { text-align: center; }
.th-strong { font-weight: 700; }
.th-logo { width: 64px; height: 64px; display: inline-block; }
.th-company { margin-top: 8px; }
.th-banner { margin-top: 8px; white-space: pre-wrap; overflow-wrap: anywhere; }
.th-item { margin-top: 6px; }
.th-word { margin-top: 8px; }
.th-invoice-barcode { margin-top: 8px; margin-bottom: 4px; line-height: 0; }
.th-invoice-barcode img {
  max-width: 70mm; max-height: 50px; width: auto; height: 50px;
  object-fit: contain; display: inline-block; vertical-align: middle;
}
.th-powered { margin-top: 10px; font-size: 10px; }
.hm-inv-thermal .co-name { font-size: 14px; }
.th-dash { border-top: 1px dashed #1c1917; margin: 6px 0; }
.th-pair { display: flex; justify-content: space-between; gap: 8px; }

.hm-inv-a4 {
  font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  font-size: 13px;
  line-height: 1.45;
}
.a4-head { padding-bottom: 14px; border-bottom: 2px solid #1c1917; }
.a4-top { display: flex; justify-content: space-between; gap: 24px; }
.co-block { display: flex; align-items: flex-start; gap: 12px; }
.co-logo { width: 72px; height: 72px; object-fit: contain; flex: 0 0 auto; }
.inv-banner {
  text-align: center; font-weight: 700; margin-top: 12px;
  white-space: pre-wrap; overflow-wrap: anywhere;
}
.inv-footer-msg {
  text-align: center; margin: 18px 0 0;
  white-space: pre-wrap; overflow-wrap: anywhere;
}
.inv-invoice-barcode { text-align: center; margin: 12px 0 6px; line-height: 0; }
.inv-invoice-barcode img {
  max-width: 220px; max-height: 50px; width: auto; height: 50px;
  object-fit: contain; display: inline-block; vertical-align: middle;
}
.inv-powered { text-align: center; margin: 10px 0 0; font-size: 11px; color: #78716c; }
.hm-paper-a5 .hm-inv-a4 { font-size: 11px; line-height: 1.3; }
.hm-paper-a5 .co-name { font-size: 15px; }
.hm-paper-a5 .co-logo { width: 44px; height: 44px; }
.hm-paper-a5 .inv-title { font-size: 14px; letter-spacing: 0.1em; margin-bottom: 2px; }
.hm-paper-a5 .a4-totals { width: min(100%, 280px); margin-top: 8px; }
.hm-paper-a5 .a4-head { padding-bottom: 8px; }
.hm-paper-a5 .inv-banner { margin-top: 6px; }
.hm-paper-a5 .bill-to { margin: 8px 0; gap: 4px 10px; }
.hm-paper-a5 .a4-items { margin-top: 8px; }
.hm-paper-a5 .a4-items th,
.hm-paper-a5 .a4-items td { padding: 3px 4px; }
.hm-paper-a5 .a4-totals td { padding: 2px 0; }
.hm-paper-a5 .a4-totals .grand td { padding-top: 4px; }
.hm-paper-a5 .in-word { margin: 8px 0 0; padding: 6px 8px; }
.hm-paper-a5 .inv-footer-msg { margin: 8px 0 0; }
.hm-paper-a5 .inv-invoice-barcode { margin: 6px 0 4px; }
.hm-paper-a5 .inv-invoice-barcode img { max-height: 40px; height: 40px; }
.hm-paper-a5 .inv-powered { margin: 4px 0 0; font-size: 10px; }
.co-name { font-size: 22px; font-weight: 700; letter-spacing: -0.02em; }
.co-line { color: #57534e; margin-top: 2px; }
.a4-meta { text-align: right; color: #44403c; }
.inv-title { font-size: 20px; font-weight: 700; letter-spacing: 0.16em; margin-bottom: 8px; }
.bill-to {
  display: grid; grid-template-columns: 88px 1fr; gap: 6px 12px;
  margin: 16px 0 18px; padding: 12px 14px; background: #fafaf9; border-radius: 8px;
}
.bill-to span:nth-child(odd) { color: #78716c; }
.a4-items { width: 100%; border-collapse: collapse; }
.a4-items th {
  padding: 8px 10px; font-size: 11px; font-weight: 700; letter-spacing: 0.04em;
  text-transform: uppercase; color: #57534e; background: #f5f5f4;
  border-bottom: 1px solid #d6d3d1; text-align: left;
}
.a4-items td { padding: 9px 10px; border-bottom: 1px solid #e7e5e4; }
.a4-items .c, .a4-totals .c { text-align: center; }
.a4-items .r, .a4-totals .r { text-align: right; font-variant-numeric: tabular-nums; }
.a4-totals { width: 360px; margin: 14px 0 0 auto; border-collapse: collapse; }
.a4-totals td { padding: 4px 0; }
.a4-totals .grand td {
  padding-top: 8px; border-top: 2px solid #1c1917; font-weight: 700;
}
.in-word {
  margin: 18px 0 0; padding: 10px 12px; background: #fafaf9;
  border-left: 3px solid #1c1917;
}
.signs {
  display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 18px;
  margin-top: 36px; text-align: center; color: #57534e; font-size: 12px;
}
.signs span {
  display: block; height: 52px; border-bottom: 1px solid #a8a29e; margin-bottom: 8px;
}
`;

function discountLabel(style, summary, payload) {
  if (style !== 4 || !(Number(summary.discount) > 0)) return "Discount";
  const percent = payload.discount_percent;
  return percent != null && percent !== "" && Number(percent) !== 0
    ? `Discount (${percent}%)`
    : "Discount";
}

function vatLabel(summary, payload) {
  if (!(Number(summary.vat) > 0)) return "VAT";
  const percent = payload.vat_percent;
  return percent != null && percent !== "" && Number(percent) !== 0
    ? `VAT (${percent}%)`
    : "VAT";
}

function invoiceProductName(item, { warrantyLayout = false } = {}) {
  let name = item?.item_name || "";
  if (item?.variant_label) {
    name += ` (${item.variant_label})`;
  }
  if (item?.is_warranty && item?.serial_number && !warrantyLayout) {
    name += ` [SN: ${item.serial_number}]`;
  }
  return name;
}

function buildThermalHtml(payload) {
  const company = payload.company || {};
  const customer = payload.customer || {};
  const summary = payload.summary || {};
  const items = payload.items || [];
  const style = Number(payload.invoice_style);
  const voucherId = esc(payload.voucher_id);
  const barcode = payload.invoice_barcode
    ? `data:image/png;base64,${payload.invoice_barcode}`
    : "";
  const showBarcode = !!company.show_barcode && !!barcode;
  const logo = absUrl(company.logo);

  const itemRows = items
    .map((item, index) => {
      const qty = item.unit ? `${item.qty} ${item.unit}` : item.qty;
      const warrantyLine =
        item.is_warranty && item.warranty_period_days
          ? `<div style="font-size:0.72rem;">Warranty: ${esc(item.warranty_period_days)} days (${esc(item.warranty_start || "-")} to ${esc(item.warranty_end || "-")})</div>`
          : "";
      return `
        <div class="th-item">
          <div>${index + 1}. ${esc(invoiceProductName(item))}</div>
          ${warrantyLine}
          <div class="th-pair">
            <span>${esc(qty)} × ${esc(item.unit_price)}</span>
            <span>${esc(item.total_price)}</span>
          </div>
        </div>`;
    })
    .join("");

  const vatRow =
    style === 4
      ? `<div class="th-pair"><span>${esc(vatLabel(summary, payload))}</span><span>${money(summary.vat)}</span></div>`
      : "";

  return `
    <div id="invoice" class="hm-paper hm-paper-thermal">
      <div class="hm-inv hm-inv-thermal">
        ${logo ? `<div class="th-center"><img src="${esc(logo)}" class="co-logo th-logo" alt=""></div>` : ""}
        <div class="th-center th-company">
          <div class="th-strong co-name">${esc(company.name)}</div>
          ${company.address ? `<div>${esc(company.address)}</div>` : ""}
          ${company.phone ? `<div>Phone: ${esc(company.phone)}</div>` : ""}
          ${company.email ? `<div>Email: ${esc(company.email)}</div>` : ""}
          ${company.tin ? `<div>TIN: ${esc(company.tin)}</div>` : ""}
          ${company.bin ? `<div>BIN: ${esc(company.bin)}</div>` : ""}
        </div>
        ${company.header_message ? `<div class="th-center th-strong th-banner">${esc(company.header_message)}</div>` : ""}
        <div class="th-dash"></div>
        <div class="th-center th-strong">INVOICE</div>
        <div class="th-pair"><span>Invoice No:</span><span>${voucherId}</span></div>
        <div class="th-pair"><span>Date:</span><span>${esc(new Date().toLocaleString())}</span></div>
        <div class="th-pair"><span>User:</span><span>${esc(payload.user)}</span></div>
        <div class="th-dash"></div>
        <div class="th-pair"><span>To:</span><span>${esc(customer.name)}</span></div>
        <div class="th-pair"><span>Contact:</span><span>${esc(customer.phone)}</span></div>
        <div class="th-pair"><span>Address:</span><span>${esc(customer.address)}</span></div>
        <div class="th-dash"></div>
        ${itemRows}
        <div class="th-dash"></div>
        <div class="th-pair"><span>Total Amount</span><span>${money(summary.sub_total)}</span></div>
        <div class="th-pair"><span>${esc(discountLabel(style, summary, payload))}</span><span>${money(summary.discount)}</span></div>
        ${vatRow}
        <div class="th-pair"><span>Net Payable</span><span>${money(summary.total)}</span></div>
        <div class="th-pair"><span>Rounded Payable</span><span>${money(summary.rounded_payable ?? summary.total)}</span></div>
        <div class="th-pair"><span>Paid Amount</span><span>${money(summary.received)}</span></div>
        <div class="th-pair"><span>Change</span><span>${money(summary.change ?? 0)}</span></div>
        <div class="th-pair"><span>Due</span><span>${money(summary.due ?? 0)}</span></div>
        <div class="th-dash"></div>
        <div class="th-pair th-strong"><span>Grand Total</span><span>${money(summary.rounded_payable ?? summary.total)}</span></div>
        <div class="th-word"><b>In Word:</b> ${esc(summary.amount_in_words)}</div>
        ${company.footer_message ? `<div class="th-center th-banner">${esc(company.footer_message)}</div>` : ""}
        ${showBarcode ? `<div class="th-center th-invoice-barcode"><img src="${barcode}" alt="Invoice barcode" /></div>` : ""}
        <div class="th-center th-powered">Powered by otobonik | www.otobonik.com | 01816293649</div>
      </div>
    </div>`;
}

function buildPageHtml(payload) {
  const company = payload.company || {};
  const customer = payload.customer || {};
  const summary = payload.summary || {};
  const items = payload.items || [];
  const style = Number(payload.invoice_style);
  const isA5 = style === 2;
  const isWarranty = style === 5;
  const paperId = isA5 ? "invoice-a5" : isWarranty ? "invoice-a4-warranty" : "invoice-a4";
  const voucherId = esc(payload.voucher_id);
  const barcode = payload.invoice_barcode
    ? `data:image/png;base64,${payload.invoice_barcode}`
    : "";
  const showBarcode = !!company.show_barcode && !!barcode;
  const logo = absUrl(company.logo);

  const itemRows = items
    .map((item, i) => {
      const qty = item.unit ? `${item.qty} ${item.unit}` : item.qty;
      if (isWarranty) {
        return `
          <tr>
            <td class="c">${i + 1}</td>
            <td>${esc(item.item_name)}</td>
            <td>${esc(item.is_warranty ? (item.variant_label || "-") : "-")}</td>
            <td>${esc(item.is_warranty ? (item.serial_number || "-") : "-")}</td>
            <td class="c">${esc(item.is_warranty ? (item.warranty_period_days || "-") : "-")}</td>
            <td class="c">${esc(item.is_warranty ? (item.warranty_start || "-") : "-")}</td>
            <td class="c">${esc(item.is_warranty ? (item.warranty_end || "-") : "-")}</td>
            <td class="r">${esc(qty)}</td>
            <td class="r">${esc(item.unit_price)}</td>
            <td class="r">${esc(item.total_price)}</td>
          </tr>`;
      }
      return `
        <tr>
          <td class="c">${i + 1}</td>
          <td>${esc(invoiceProductName(item))}</td>
          <td class="r">${esc(qty)}</td>
          <td class="r">${esc(item.unit_price)}</td>
          <td class="r">${esc(item.total_price)}</td>
        </tr>`;
    })
    .join("");

  const signs =
    style !== 2
      ? `<div class="signs">
          <div><span></span>Received By</div>
          <div><span></span>Checked By</div>
          <div><span></span>Authorized By</div>
        </div>`
      : "";

  const thead = isWarranty
    ? `<tr>
        <th class="c">#</th>
        <th>Product</th>
        <th>Variant</th>
        <th>Serial</th>
        <th class="c">Warranty Days</th>
        <th class="c">Start</th>
        <th class="c">End</th>
        <th class="r">Qty</th>
        <th class="r">Unit Price</th>
        <th class="r">Amount</th>
      </tr>`
    : `<tr>
        <th class="c">#</th>
        <th>Product Name</th>
        <th class="r">Qty</th>
        <th class="r">Unit Price</th>
        <th class="r">Amount</th>
      </tr>`;

  return `
    <div id="${paperId}" class="hm-paper${isA5 ? " hm-paper-a5" : ""}${isWarranty ? " hm-paper-warranty" : ""}">
      <div class="hm-inv hm-inv-a4">
        <div class="a4-head">
          <div class="a4-top">
            <div class="co-block">
              ${logo ? `<img src="${esc(logo)}" class="co-logo" alt="">` : ""}
              <div>
                <div class="co-name">${esc(company.name)}</div>
                ${company.address ? `<div class="co-line">${esc(company.address)}</div>` : ""}
                ${company.phone ? `<div class="co-line">Phone: ${esc(company.phone)}</div>` : ""}
                ${company.email ? `<div class="co-line">Email: ${esc(company.email)}</div>` : ""}
                ${company.tin ? `<div class="co-line">TIN: ${esc(company.tin)}</div>` : ""}
                ${company.bin ? `<div class="co-line">BIN: ${esc(company.bin)}</div>` : ""}
              </div>
            </div>
            <div class="a4-meta">
              <div class="inv-title">${isWarranty ? "WARRANTY INVOICE" : "INVOICE"}</div>
              <div>Invoice No: ${voucherId}</div>
              <div>Date: ${esc(new Date().toLocaleString())}</div>
              <div>User: ${esc(payload.user)}</div>
            </div>
          </div>
          ${company.header_message ? `<div class="inv-banner">${esc(company.header_message)}</div>` : ""}
        </div>
        <div class="bill-to">
          <span>To:</span><span>${esc(customer.name)}</span>
          <span>Contact:</span><span>${esc(customer.phone)}</span>
          <span>Address:</span><span>${esc(customer.address)}</span>
        </div>
        <table class="a4-items${isWarranty ? " a4-items-warranty" : ""}">
          <thead>${thead}</thead>
          <tbody>${itemRows}</tbody>
        </table>
        <table class="a4-totals">
          <tbody>
            <tr><td>Total Amount</td><td class="r">${money(summary.sub_total)}</td></tr>
            <tr><td>Discount</td><td class="r">${money(summary.discount)}</td></tr>
            <tr><td>Net Payable</td><td class="r">${money(summary.total)}</td></tr>
            <tr><td>Rounded Payable</td><td class="r">${money(summary.rounded_payable ?? summary.total)}</td></tr>
            <tr><td>Paid Amount</td><td class="r">${money(summary.received)}</td></tr>
            <tr><td>Change</td><td class="r">${money(summary.change ?? 0)}</td></tr>
            <tr><td>Due</td><td class="r">${money(summary.due ?? 0)}</td></tr>
            <tr class="grand"><td>Grand Total</td><td class="r">${money(summary.rounded_payable ?? summary.total)}</td></tr>
          </tbody>
        </table>
        <p class="in-word"><b>In Word:</b> ${esc(summary.amount_in_words)}</p>
        ${signs}
        ${company.footer_message ? `<p class="inv-footer-msg">${esc(company.footer_message)}</p>` : ""}
        ${showBarcode ? `<div class="inv-invoice-barcode"><img src="${barcode}" alt="Invoice barcode" /></div>` : ""}
        <p class="inv-powered">Powered by otobonik | www.otobonik.com | 01816293649</p>
      </div>
    </div>`;
}

function buildInvoiceBodyHtml(payload) {
  const style = Number(payload.invoice_style);
  if (style === 1 || style === 2 || style === 5) return buildPageHtml(payload);
  return buildThermalHtml(payload);
}

function buildPrintDocument(payload) {
  const style = Number(payload.invoice_style);
  const isA5 = style === 2;
  const isA4 = style === 1 || style === 5;
  const isThermal = !isA4 && !isA5;
  const bodyHtml = buildInvoiceBodyHtml(payload);

  // Thermal @page height is set after render from real scrollHeight (same as InvoicePrint).
  const pageSize = isA5 ? "A5" : isA4 ? "A4" : "80mm 200mm";
  const pageMargin = isA5 ? "8mm 8mm 8mm 8mm" : isA4 ? "18mm 16mm 20mm 16mm" : "0";
  const thermalCss = isThermal
    ? `
      #invoice, .hm-paper-thermal {
        box-sizing: border-box !important;
        width: 80mm !important;
        max-width: 80mm !important;
        max-height: none !important;
        padding: 4mm !important;
      }
      @media screen { html, body { width: 80mm; } }
      @media print {
        #invoice {
          box-sizing: border-box !important;
          width: 80mm !important;
          max-width: 80mm !important;
          max-height: none !important;
          padding: 4mm !important;
        }
      }`
    : "";

  // Firefox fires afterprint when the print clone is ready (dialog may still be open).
  // Close after leaving print media, or on focus return after a blur (dialog dismissed).
  const autoCloseScript = `
<script>
(function () {
  var poll = null;
  function tryClose() {
    try {
      if (window.closed) {
        if (poll) { clearInterval(poll); poll = null; }
        return;
      }
      window.close();
    } catch (e) {}
  }
  function startClosePoll() {
    tryClose();
    if (poll) return;
    poll = setInterval(tryClose, 300);
    setTimeout(function () {
      if (poll) { clearInterval(poll); poll = null; }
    }, 120000);
  }
  function onAfterPrint() {
    // Chrome: dialog already gone.
    // Firefox: afterprint fires while dialog may still be open — keep retrying close.
    var blurred = false;
    window.addEventListener("blur", function () { blurred = true; }, { once: true });
    window.addEventListener("focus", function () {
      if (blurred) startClosePoll();
    }, { once: true });
    setTimeout(startClosePoll, 1000);
  }
  window.addEventListener("afterprint", onAfterPrint);
  window.onafterprint = onAfterPrint;
  try {
    var mql = window.matchMedia("print");
    var onChange = function (e) {
      if (e && e.matches === false) startClosePoll();
    };
    if (mql && mql.addEventListener) mql.addEventListener("change", onChange);
    else if (mql && mql.addListener) mql.addListener(onChange);
  } catch (e) {}
})();
</script>`;

  return `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>Print Preview</title>
    <base href="${window.location.origin}/">
    <style>${INVOICE_CSS}</style>
    <style id="hm-page-style">
      @page { size: ${pageSize}; margin: ${pageMargin}; }
      html, body { margin: 0; background: #fff; }
      @media screen { body { padding: ${pageMargin}; } }
      .hm-paper, #invoice, #invoice-a4, #invoice-a5, #invoice-a4-warranty {
        box-sizing: border-box !important;
        position: static !important;
        width: 100% !important;
        max-width: 100% !important;
        max-height: none !important;
        margin: 0 !important;
        overflow: visible !important;
        box-shadow: none !important;
      }
      .a4-items-warranty th,
      .a4-items-warranty td { font-size: 11px; padding: 6px 4px; }
      @media print {
        body, body * { visibility: visible !important; }
        body { padding: 0 !important; }
      }
      ${thermalCss}
    </style>
  </head>
  <body>
    ${bodyHtml}
    ${autoCloseScript}
  </body>
</html>`;
}

function waitForImages(doc) {
  const images = Array.from(doc.images || []);
  if (!images.length) return Promise.resolve();
  return Promise.race([
    Promise.all(
      images.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.onload = img.onerror = () => resolve();
            })
      )
    ),
    new Promise((resolve) => setTimeout(resolve, 2000)),
  ]);
}

/** Match InvoicePrint: one continuous 80mm roll from measured content height. */
function applyThermalPageSize(doc) {
  const source = doc.getElementById("invoice");
  if (!source) return;
  const heightMm = Math.max(40, Math.ceil((source.scrollHeight * 25.4) / 96) + 12);
  const pageMargin = "0";
  let styleEl = doc.getElementById("hm-page-style");
  if (!styleEl) {
    styleEl = doc.createElement("style");
    styleEl.id = "hm-page-style";
    doc.head.appendChild(styleEl);
  }
  // Keep non-@page rules; only refresh @page size from measured height.
  const base = styleEl.textContent.replace(/@page\s*\{[^}]*\}/, "").trim();
  styleEl.textContent = `@page { size: 80mm ${heightMm}mm; margin: ${pageMargin}; }\n${base}`;
}

/**
 * Show invoice print preview (same dialog as Invoice Print → Print).
 * Parent window runs print() and close() — reliable auto-close on Firefox/macOS.
 * @param {object} payload - API response from invoice/print/?detail=1
 * @param {{ targetWindow?: Window|null }} [options]
 */
export async function openInvoicePrintPreview(payload, options = {}) {
  if (!payload || !Array.isArray(payload.items) || !payload.items.length) {
    throw new Error("Invoice data is empty");
  }

  const html = buildPrintDocument(payload);
  let target = options.targetWindow && !options.targetWindow.closed
    ? options.targetWindow
    : null;

  if (!target) {
    target = window.open("about:blank", "hmPosInvoicePrint");
  }
  if (!target) {
    throw new Error("Pop-up blocked");
  }

  try {
    target.document.open();
    target.document.write(html);
    target.document.close();
  } catch (err) {
    throw new Error("Could not write print preview");
  }

  await waitForImages(target.document);
  await new Promise((r) => setTimeout(r, 150));

  if (target.closed) return target;

  // Same measurement as /print/invoice — avoids short @page height splitting the roll.
  const style = Number(payload.invoice_style);
  if (style !== 1 && style !== 2 && style !== 5) {
    applyThermalPageSize(target.document);
  }

  // Opener-side close: Firefox often ignores close() while the dialog is open,
  // and fires afterprint too early. Close when dialog is gone (focus back / poll).
  let armed = false;
  let pollId = null;
  const stopPoll = () => {
    if (pollId != null) {
      clearInterval(pollId);
      pollId = null;
    }
  };
  const tryClose = () => {
    try {
      if (!target || target.closed) {
        stopPoll();
        return;
      }
      target.close();
      if (target.closed) stopPoll();
    } catch (err) { /* ignore */ }
  };
  const armClose = () => {
    if (armed) return;
    armed = true;
    // When print UI dismisses, focus usually returns to opener or popup.
    try {
      window.addEventListener("focus", tryClose, { once: true });
    } catch (err) { /* ignore */ }
    try {
      target.addEventListener("focus", tryClose, { once: true });
    } catch (err) { /* ignore */ }
    pollId = setInterval(tryClose, 300);
    setTimeout(stopPoll, 120000);
  };

  try {
    target.addEventListener("afterprint", armClose);
    target.onafterprint = armClose;
  } catch (err) { /* ignore */ }

  try {
    target.focus();
  } catch (err) { /* ignore */ }

  try {
    target.print();
  } catch (err) { /* ignore */ }

  // If print() blocked until dismiss, close now. If not, armClose handles it.
  armClose();
  tryClose();

  return target;
}

export default openInvoicePrintPreview;
